import { render, staticRenderFns } from "./HuliNavigation.vue?vue&type=template&id=2ac25a14"
import script from "./HuliNavigation.vue?vue&type=script&lang=js"
export * from "./HuliNavigation.vue?vue&type=script&lang=js"
import style0 from "./HuliNavigation.vue?vue&type=style&index=0&id=2ac25a14&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports